import React, {useState, useRef, useEffect} from 'react';
import {IProps} from './types';
import RemoveIconWhite from '@assets/icons/removeIconWhite';
import * as S from './styles';

const MoreChips:React.FC<IProps> = (props) => {
  const [showMenu, setShowMenu]= useState(false)
  const componentRef = useRef(null);

  const handleClickBtnMore = ()=>setShowMenu(!showMenu);

  const handleClickRemove = (index:number)=>{
    setTimeout(function() {
      props.handleRemove(index);
   }, 500);
  };

  const handleClickOutside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target))setShowMenu(false);
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])

  return (
    <S.Root ref={componentRef}>
      <S.BtnMore onClick={handleClickBtnMore} radius={showMenu? "18px 18px 0px 0px":"20px"} height={showMenu? "38px":"31px"}>
        +{props.chips.length}
      </S.BtnMore>

      {!showMenu &&
      <S.ClearAllHide style={props.styleLabel} onClick={() => props.handleRemoveAlll()}>
        Clear All Filters
      </S.ClearAllHide>
      }

      <S.MenuChips style={{display: showMenu?'block':'none'}}>
        <S.Title>Additional Filters:</S.Title>
        <S.Scroll>
            {props.chips.map((text:string, index:number) => 
              <S.Chip key={`chip${index}`}>
                {text}
                <S.Remove onClick={() => handleClickRemove(index+props.nchips)} >
                      <RemoveIconWhite style={{marginTop: '2px'}}/>
                </S.Remove>
              </S.Chip>
            )}
        </S.Scroll>
        <S.ClearAll onClick={() => props.handleRemoveAlll()}>
          {`Clear all (${props.chips.length+props.nchips}) Filters`}
        </S.ClearAll>
      </S.MenuChips>
    </S.Root >
  );
}

export default MoreChips;